const Card3 = (props?: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 338 246"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
  >
    <path
      d="M214.469 224.414L214.745 224.188H215.103H229.283H304.142L337 202.735V21.2538L304.166 1.85864H1.50497V224.537L47.0394 244.708H189.693L214.469 224.414Z"
      fill="url(#paint0_linear_83_680)"
      fillOpacity="0.7"
      stroke="url(#paint1_linear_83_680)"
      strokeWidth="2"
    />
    <clipPath
      id="card3-clippy"
      clipPathUnits="objectBoundingBox"
      transform="scale(0.0029585798816568,0.0040650406504065)"
      preserveAspectRatio="none"
    >
      <path
        d="M214.469 224.414L214.745 224.188H215.103H229.283H304.142L337 202.735V21.2538L304.166 1.85864H1.50497V224.537L47.0394 244.708H189.693L214.469 224.414Z"
        strokeWidth="2"
      />
    </clipPath>
    <defs>
      <linearGradient
        id="paint0_linear_83_680"
        x1="169.252"
        y1="0.858643"
        x2="169.252"
        y2="245.708"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.458807" stopColor="#050809" stopOpacity="0.45" />
        <stop offset="1" stopColor="#292023" stopOpacity="0.45" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_83_680"
        x1="348.399"
        y1="-28.0086"
        x2="124.017"
        y2="309.366"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E728E8" />
        <stop offset="1" stopColor="#0228E8" />
      </linearGradient>
    </defs>
  </svg>
);

export default Card3;
